
<template>
    <BaseContainer>
        <template slot="menu">
            <v-app-bar app dark>
                <v-btn icon @click="goBack">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-spacer />
                <span style="text-transform: uppercase; font-weight: bold;">{{ $t('envio.titulo') }}</span>
                <v-spacer />
            </v-app-bar>
        </template>
        <template slot="principal">
            <v-main>
                <v-card elevation="0" style="margin-bottom: 200px !important;">
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col cols="6">
                                <v-text-field
                                    v-model="nome"
                                    :label="$t('envio.nomeCompleto')"
                                    ref="nome"
                                    prepend-inner-icon="mdi-account"
                                    hide-details
                                    outlined
                                    dense
                                />
                            </v-col>
                            <v-col cols="6">
                                <TelefoneInput
                                    v-model="telefone"
                                    :ddi.sync="telefoneDdi"
                                    :label="$t('envio.whatsapp')"
                                    ref="telefone"
                                    type="tel"
                                    prepend-inner-icon="mdi-whatsapp"
                                    :mascara-brasil="['(##) # #### ####']"
                                    hide-details
                                    outlined
                                    dense
                                    :disabled="!!cliente.id"
                                />
                            </v-col>
                        </v-row>

                        <v-row v-if="pedirEmail" align="center" justify="center" class="mt-2">
                            <v-col cols="12">
                                <v-text-field
                                    v-model="email"
                                    :label="$t('envio.emailOpcional')"
                                    type="email"
                                    prepend-inner-icon="mdi-email-outline"
                                    :hint="$t('envio.emailDica')"
                                    persistent-hint
                                    outlined
                                    dense
                                />
                            </v-col>
                        </v-row>

                        <v-row v-if="exibirAniversario" align="center" justify="center">
                            <v-col cols="12">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    :label="$t('envio.aniversario')"
                                    v-model="nascimento"
                                    :placeholder="formatoAniversario"
                                    v-mask="['##/##']"
                                />
                            </v-col>
                        </v-row>

                        <v-row align="center" justify="center" class="mt-2">
                            <v-col cols="12">
                                <v-btn-toggle
                                    v-model="formaEntrega"
                                    @change="onChangeFormaEntrega"
                                    :style="cssVars"
                                    rounded
                                >
                                    <v-btn
                                        v-if="deliveryEnabled"
                                        :value="2"
                                        style="font-size: 10px; height: 60px; width: 30%;"
                                    >
                                        <v-col cols="12">
                                            <v-row
                                                width="100%"
                                                style="place-content: center; margin-bottom: 5px;"
                                            >
                                                <v-icon
                                                    class="mr-2"
                                                    :color="isDelivery ? '#fff' : $vuetify.theme.isDark ? '#fff' : '#000'"
                                                >
                                                    mdi-bike-fast
                                                </v-icon>
                                            </v-row>
                                            <v-row width="100%" style="place-content: center">
                                                <span><b>{{ $t('envio.entregar') }}</b></span>
                                            </v-row>
                                        </v-col>
                                    </v-btn>

                                    <v-btn
                                        v-if="retiradaEnabled"
                                        :value="1"
                                        style="font-size: 10px; height: 60px; width: 30%;"
                                    >
                                        <v-col cols="12">
                                            <v-row
                                                width="100%"
                                                style="place-content: center; margin-bottom: 5px;"
                                            >
                                                <v-icon
                                                    class="mr-2"
                                                    :color="isRetirada ? '#fff' : $vuetify.theme.isDark ? '#fff' : '#000'"
                                                >
                                                    mdi-walk
                                                </v-icon>
                                            </v-row>
                                            <v-row width="100%" style="place-content: center">
                                                <span><b>{{ $t('envio.vouRetirar') }}</b></span>
                                            </v-row>
                                        </v-col>
                                    </v-btn>

                                    <v-btn
                                        v-if="localEnabled"
                                        :value="3"
                                        style="font-size: 10px; height: 60px; width: 30%;"
                                    >
                                        <v-col cols="12">
                                            <v-row
                                                width="100%"
                                                style="place-content: center; margin-bottom: 5px;"
                                            >
                                                <v-icon
                                                    class="mr-2"
                                                    :color="isLocal ? '#fff' : $vuetify.theme.isDark ? '#fff' : '#000'"
                                                >
                                                    mdi-map-marker
                                                </v-icon>
                                            </v-row>
                                            <v-row width="100%" style="place-content: center">
                                                <span><b>{{ $t('envio.consumirNoLocal1') }}<br/>{{ $t('envio.consumirNoLocal2') }}</b></span>
                                            </v-row>
                                        </v-col>
                                    </v-btn>
                                </v-btn-toggle>
                            </v-col>
                        </v-row>

                        <v-row
                            v-if="formaEntrega && permitirAgendamento && !agendamentoObrigatorio"
                            style="margin-top: -10px; margin-bottom: -10px;"
                        >
                            <v-col class="mt-2">
                                <div>{{ $t('envio.quandoSera') }}</div>
                                <v-radio-group
                                    v-model="agendado"
                                    row
                                    hide-details
                                    style="margin-top: 5px;"
                                >
                                    <v-radio
                                        :label="$t('envio.hoje')"
                                        :value="false"
                                    />
                                    <v-radio
                                        :label="$t('envio.agendar')"
                                        :value="true"
                                    />
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row v-if="formaEntrega && agendado">
                            <v-col class="py-1">
                                <v-select
                                    v-model="agendado_data"
                                    :items="agendamentoDatas"
                                    @change="onChangeAgendadoData"
                                    :label="$t('envio.dataAgendamento')"
                                    prepend-inner-icon="mdi-calendar"
                                    hide-details
                                    dense
                                    outlined
                                />
                            </v-col>
                            <v-col v-if="agendamentoExibirHorario" class="py-1">
                                <v-select
                                    v-model="agendado_hora"
                                    :label="$t('envio.horario')"
                                    :items="horarios"
                                    :disabled="!agendado_data"
                                    prepend-inner-icon="mdi-clock-outline"
                                    hide-details
                                    dense
                                    outlined
                                />
                            </v-col>
                        </v-row>

                        <v-row v-if="isDelivery" align="center" justify="center">
                            <v-col cols="12">
                                <v-card
                                    outlined
                                    class="pa-3 d-flex align-center endereco-resumo"
                                    :class="{
                                        'endereco-resumo--ativo': enderecoAtualResumo,
                                        'endereco-resumo--trace': pulseEndereco,
                                    }"
                                    :style="{
                                        '--trace-color': $theme.primary,
                                        ...(enderecoAtualResumo ? { borderColor: $theme.primary } : {}),
                                    }"
                                >
                                    <v-icon color="primary" class="mr-3">mdi-map-marker</v-icon>
                                    <div class="flex-grow-1" style="min-width: 0">
                                        <div class="text-caption grey--text text--darken-1">{{ $t('envio.enderecoEntrega') }}</div>
                                        <div class="text-body-2 font-weight-medium" style="line-height: 1.3">
                                            {{ enderecoAtualResumo || $t('envio.informeEnderecoEntrega') }}
                                        </div>
                                    </div>
                                    <v-btn
                                        v-if="enderecoAtualResumo"
                                        text
                                        small
                                        color="primary"
                                        class="ml-2"
                                        @click="alterarEndereco"
                                    >
                                        {{ $t('envio.alterar') }}
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        text
                                        small
                                        color="primary"
                                        class="ml-2"
                                        @click="abrirFormEndereco('novo')"
                                    >
                                        {{ $t('envio.informar') }}
                                    </v-btn>
                                </v-card>
                            </v-col>
                        </v-row>

                        <v-dialog v-model="dialogEnderecos" max-width="480" scrollable>
                            <v-card class="d-flex flex-column" style="min-height: 340px">
                                <v-card-title class="py-2 px-2 d-flex align-center">
                                    <v-btn icon @click="dialogEnderecos = false">
                                        <v-icon>mdi-arrow-left</v-icon>
                                    </v-btn>
                                    <div
                                        class="flex-grow-1 text-center text-uppercase font-weight-medium"
                                        style="font-size: 1.1rem; letter-spacing: 0.5px"
                                    >
                                        {{ $t('envio.seusEnderecos') }}
                                    </div>
                                    <div style="flex: 0 0 36px"></div>
                                </v-card-title>
                                <v-divider />
                                <v-card-text class="pa-3 flex-grow-1">
                                    <v-card
                                        v-for="end in enderecosSalvos"
                                        :key="end.uuid"
                                        class="mb-2"
                                        style="cursor: pointer"
                                        :color="end.uuid === selectedEnderecoUuid ? '' : 'grey lighten-4'"
                                        :outlined="end.uuid === selectedEnderecoUuid"
                                        :elevation="end.uuid === selectedEnderecoUuid ? 2 : 0"
                                        rounded
                                        @click="selecionarEndereco(end)"
                                    >
                                        <v-list-item>
                                            <v-list-item-icon class="my-auto mr-3">
                                                <v-icon :color="end.uuid === selectedEnderecoUuid ? 'primary' : 'grey'">
                                                    {{ end.uuid === selectedEnderecoUuid ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                                                </v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title class="d-flex align-center">
                                                    <v-icon small color="primary" class="mr-2">{{ tipoIcon(end.tipo_local) }}</v-icon>
                                                    {{ enderecoLabel(end) }}
                                                    <v-chip v-if="end.padrao" x-small color="primary" outlined class="ml-2">{{ $t('endereco.padrao') }}</v-chip>
                                                </v-list-item-title>
                                                <v-list-item-subtitle style="white-space: normal">
                                                    {{ enderecoResumo(end) }}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action class="my-auto" style="flex-direction: row; align-items: center">
                                                <v-btn icon small @click.stop="editarEndereco(end)">
                                                    <v-icon small color="grey darken-1">mdi-pencil-outline</v-icon>
                                                </v-btn>
                                                <v-menu v-if="isLogado" offset-y left>
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn icon small v-bind="attrs" v-on="on" @click.stop>
                                                            <v-icon small color="grey darken-1">mdi-dots-vertical</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-list dense>
                                                        <v-list-item v-if="!end.padrao" @click="definirEnderecoPadrao(end)">
                                                            <v-icon small class="mr-2">mdi-star-outline</v-icon>
                                                            {{ $t('envio.definirPadrao') }}
                                                        </v-list-item>
                                                        <v-list-item @click="excluirEndereco(end)">
                                                            <v-icon small class="mr-2" color="error">mdi-delete-outline</v-icon>
                                                            {{ $t('envio.excluir') }}
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-card>
                                </v-card-text>
                                <v-divider />
                                <v-card-actions class="d-flex flex-column pa-2">
                                    <v-btn block text color="primary" @click="cadastrarOutroEndereco">
                                        <v-icon left>mdi-plus</v-icon> {{ $t('envio.cadastrarOutro') }}
                                    </v-btn>
                                    <v-btn
                                        v-if="isLogado"
                                        block
                                        text
                                        small
                                        color="grey darken-1"
                                        class="mt-1 ml-0"
                                        @click="gerenciarEnderecos"
                                    >
                                        <v-icon left small>mdi-cog-outline</v-icon> {{ $t('envio.gerenciarEnderecos') }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <v-dialog v-model="dialogEnderecoForm" max-width="560" scrollable persistent>
                            <v-card>
                                <v-card-title class="py-2 px-2 d-flex align-center">
                                    <v-btn
                                        icon
                                        :style="{ visibility: voltarChooser ? 'visible' : 'hidden' }"
                                        @click="voltarParaChooser"
                                    >
                                        <v-icon>mdi-arrow-left</v-icon>
                                    </v-btn>
                                    <div
                                        class="flex-grow-1 text-center text-uppercase font-weight-medium"
                                        style="font-size: 1.1rem; letter-spacing: 0.5px"
                                    >
                                        {{ selectedEnderecoUuid ? $t('envio.editarEndereco') : $t('envio.enderecoEntrega') }}
                                    </div>
                                    <div style="flex: 0 0 36px"></div>
                                </v-card-title>
                                <v-divider />
                                <v-card-text class="pt-4">
                                    <div v-if="showAddressSelector" class="mb-4">
                                        <AddressSelector
                                            ref="addressSelector"
                                            @confirm="confirmPosition"
                                            v-model="mapCurrentGeolocation"
                                        />
                                    </div>

                                    <div v-if="exigeCep" class="d-flex" style="gap: 8px">
                                        <v-text-field
                                            :label="rotuloCodigoPostal"
                                            v-model="cep"
                                            v-mask="[paisDaLoja.codigoPostal.mascara]"
                                            :loading="loadingCep"
                                            inputmode="numeric"
                                            outlined
                                            dense
                                            @change="consultaCep"
                                        />
                                        <v-text-field
                                            :label="rotuloEstado"
                                            v-model="uf"
                                            maxlength="2"
                                            outlined
                                            dense
                                            style="max-width: 90px"
                                        />
                                    </div>

                                    <v-autocomplete
                                        v-if="showMunicipioAutocomplete"
                                        :items="municipios"
                                        return-object
                                        clearable
                                        outlined
                                        dense
                                        :label="$t('endereco.selecioneMunicipio')"
                                        v-model="municipio"
                                        @change="onChangeMunicipio"
                                        item-value="id"
                                        item-text="descricao"
                                    />
                                    <v-autocomplete
                                        v-if="showBairroAutocomplete"
                                        :items="getBairros"
                                        v-model="bairro"
                                        @change="onChangeBairro"
                                        return-object
                                        clearable
                                        outlined
                                        dense
                                        :label="$t('endereco.selecioneBairro')"
                                        item-value="id"
                                        item-text="descricao"
                                    />
                                    <v-text-field
                                        v-else
                                        v-model="bairro"
                                        :label="bairroObrigatorio ? $t('endereco.bairro') : $t('endereco.bairroOpcional')"
                                        outlined
                                        dense
                                        @change="onAddressChange"
                                    />

                                    <div class="d-flex" style="gap: 8px">
                                        <v-text-field
                                            :label="$t('endereco.rua')"
                                            v-model="rua"
                                            outlined
                                            dense
                                            @change="onAddressChange"
                                        />
                                        <v-text-field
                                            :label="$t('endereco.numero')"
                                            v-model="numero"
                                            outlined
                                            dense
                                            style="max-width: 120px"
                                            @keydown="validateAlphaNumericSpaces"
                                            @paste="onPaste"
                                            @change="onAddressChange"
                                        />
                                    </div>

                                    <v-text-field
                                        :label="$t('endereco.pontoReferencia')"
                                        v-model="complemento"
                                        outlined
                                        dense
                                    />
                                    <v-text-field
                                        :label="$t('geral.observacao')"
                                        v-model="observacaoGeral"
                                        outlined
                                        dense
                                    />

                                    <v-radio-group v-model="tipoLocal" row hide-details class="mt-0 mb-2 tipo-local-radios">
                                        <v-radio value="casa">
                                            <template #label><v-icon small class="mr-1">mdi-home-outline</v-icon>{{ $t('endereco.tipo.casa') }}</template>
                                        </v-radio>
                                        <v-radio value="apartamento">
                                            <template #label><v-icon small class="mr-1">mdi-office-building-outline</v-icon>{{ $t('endereco.tipo.apartamento') }}</template>
                                        </v-radio>
                                        <v-radio value="trabalho">
                                            <template #label><v-icon small class="mr-1">mdi-briefcase-outline</v-icon>{{ $t('endereco.tipo.trabalho') }}</template>
                                        </v-radio>
                                    </v-radio-group>

                                    <div v-if="tipoLocal === 'apartamento'" class="d-flex" style="gap: 8px">
                                        <v-text-field
                                            :label="$t('endereco.nomePredio')"
                                            v-model="nomeEdificio"
                                            outlined
                                            dense
                                            class="mb-1"
                                        />
                                        <v-text-field
                                            :label="$t('endereco.numeroApartamento')"
                                            v-model="numeroApartamento"
                                            outlined
                                            dense
                                            class="mb-1"
                                            style="max-width: 140px"
                                        />
                                    </div>
                                </v-card-text>
                                <v-divider />
                                <v-card-actions>
                                    <v-btn text @click="cancelarFormEndereco">{{ $t('geral.cancelar') }}</v-btn>
                                    <v-spacer />
                                    <v-btn color="primary" depressed @click="confirmarFormEndereco">
                                        {{ $t('envio.confirmar') }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-row v-if="hasCupom">
                            <v-col cols="12">
                                <v-subheader @click="showCupom = !showCupom" style="margin: -10px;">
                                    {{ $t('envio.temCupom') }}
                                    <v-icon class="mr-2">mdi-chevron-{{ showCupom ? 'up' : 'down' }}</v-icon>
                                </v-subheader>
                                <v-slide-y-transition>
                                    <div v-if="showCupom && !cupom">
                                        <v-text-field
                                            v-model="cupomCode"
                                            :placeholder="$t('envio.informeCupom')"
                                            prepend-inner-icon="mdi-ticket-percent-outline"
                                            hide-details
                                            clearable
                                            outlined
                                            dense
                                        >
                                            <template #append-outer>
                                                <v-btn
                                                    @click="onChangeCupom"
                                                    :loading="loadingCupom"
                                                    color="primary"
                                                    style="margin-top: -5px;"
                                                >{{ $t('envio.aplicar') }}</v-btn>
                                            </template>
                                        </v-text-field>

                                        <!-- cupom exclusivo de cliente cadastrado -->
                                        <v-alert
                                            v-if="cupomRequerLogin"
                                            color="primary"
                                            text
                                            dense
                                            class="mt-3 mb-0"
                                        >
                                            <div class="d-flex align-center justify-space-between flex-wrap" style="gap: 8px;">
                                                <span class="text-body-2">
                                                    {{ cupomPrimeiraCompra
                                                        ? $t('envio.cupomPrimeiroPedido')
                                                        : $t('envio.cupomExclusivo') }}
                                                </span>
                                                <v-btn
                                                    color="primary"
                                                    small
                                                    depressed
                                                    class="text-none"
                                                    @click="showLoginDialog = true"
                                                >
                                                    {{ cupomPrimeiraCompra ? $t('envio.entrarOuCriarConta') : $t('envio.entrar') }}
                                                </v-btn>
                                            </div>
                                        </v-alert>
                                    </div>
                                    <div v-if="showCupom && cupom">
                                        <v-chip
                                            :color="cupomValidRules ? 'success' : ''"
                                            close @click:close="removeCupom"
                                        >
                                            <v-icon class="mr-2">mdi-ticket-percent-outline</v-icon>
                                            <span>
                                                {{ cupomCode }}
                                            </span>
                                        </v-chip>
                                        <span v-if="cupomUsosRestantes !== null" class="caption ml-2 grey--text">
                                            {{ cupomUsosRestantes === 1 ? $t('envio.restaUmUso') : $t('envio.restamUsos', { n: cupomUsosRestantes }) }}
                                        </span>
                                        <div v-if="showCupom && cupomHasRules">
                                            <v-subheader class="px-0 pb-1">{{ $t('envio.regras') }}</v-subheader>
                                            <div v-if="cupom.primeira_compra">
                                                <v-icon class="mr-2" color="green">mdi-check-circle</v-icon>
                                                <span><i18n path="envio.regraPrimeiroPedido" :tag="false">
                                                    <template #destaque><b>{{ $t('envio.primeiroPedido') }}</b></template>
                                                </i18n></span>
                                            </div>

                                            <div v-if="cupom.condicoes.grupos?.length">
                                                <v-icon class="mr-2" :color="cupomValidRulesGrupos ? 'green' : 'red'">
                                                mdi-{{ cupomValidRulesGrupos ? 'check-circle' : 'close-circle-outline' }}
                                                </v-icon>
                                                <span><i18n path="envio.regraGrupos" :tag="false">
                                                    <template #lista><b>{{ getCupomGrupos }}</b></template>
                                                </i18n></span>
                                            </div>

                                            <div v-if="cupom.condicoes.formas_entrega?.length">
                                                <v-icon class="mr-2" :color="cupomValidRulesEntrega ? 'green' : 'red'">
                                                mdi-{{ cupomValidRulesEntrega ? 'check-circle' : 'close-circle-outline' }}
                                                </v-icon>
                                                <span><i18n path="envio.regraEntrega" :tag="false">
                                                    <template #lista><b>{{ getCupomFormasEntrega }}</b></template>
                                                </i18n></span>
                                            </div>

                                            <div v-if="cupom.condicoes.formas_pagamento?.length">
                                                <v-icon class="mr-2" :color="cupomValidRulesPagamento ? 'green' : 'red'">
                                                mdi-{{ cupomValidRulesPagamento ? 'check-circle' : 'close-circle-outline' }}
                                                </v-icon>
                                                <span><i18n path="envio.regraPagamento" :tag="false">
                                                    <template #lista><b>{{ getCupomFormasPagamento }}</b></template>
                                                </i18n></span>
                                            </div>

                                            <div v-if="cupomValorMinimo">
                                                <v-icon class="mr-2" :color="cupomValidRulesValorMinimo ? 'green' : 'red'">
                                                mdi-{{ cupomValidRulesValorMinimo ? 'check-circle' : 'close-circle-outline' }}
                                                </v-icon>
                                                <span>
                                                    <i18n path="envio.regraValorMinimo" :tag="false">
                                                        <template #valor><b>{{ formatMoney(cupomValorMinimo) }}</b></template>
                                                    </i18n>
                                                    <b v-if="cupomFaltaParaMinimo" class="red--text">
                                                        {{ $t('envio.faltam', { valor: formatMoney(cupomFaltaParaMinimo) }) }}
                                                    </b>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </v-slide-y-transition>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <FormaPagamentoSelect
                                    @change="formaPagamento = $event"
                                    :items="formasPagamento"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    ref="troco"
                                    type="tel"
                                    hide-details
                                    :label="$t('envio.trocoParaQuanto')"
                                    :prefix="simboloMoeda()"
                                    v-model="troco"
                                    placeholder="0.00"
                                    v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                                    v-if="pagamentoEmDinheiro && precisaTroco"
                                    outlined
                                    dense
                                />
                                <v-checkbox
                                    v-if="pagamentoEmDinheiro"
                                    dense
                                    :false-value="true"
                                    :true-value="false"
                                    v-model="precisaTroco"
                                    @change="onChangePrecisaTroco"
                                    :label="$t('envio.naoPrecisoTroco')"
                                />
                                <v-btn
                                    small
                                    class="mt-4"
                                    @click="copyPixKey"
                                    v-if="showPixDetails"
                                >
                                    {{ $t('envio.copiarPix') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-if="showPixDetails" style="margin-top: -15px;">
                            <v-col cols="12" style="display: flex;">
                                <div class="ellipsis mr-8">
                                    <v-list-item-avatar size="22">
                                        <v-icon small color="#1e1e1e" class="grey lighten-1" dark>mdi-key</v-icon>
                                    </v-list-item-avatar>
                                    {{ configuracoes.tipo_pix }}
                                </div>
                                <div class="ellipsis">
                                    <v-list-item-avatar size="22">
                                        <v-icon small color="#1e1e1e" class="grey lighten-1" dark>mdi-account</v-icon>
                                    </v-list-item-avatar>
                                    {{ configuracoes.nome_pix }}
                                </div>
                            </v-col>
                        </v-row>
                        <input type="hidden" id="pixKey" :value="configuracoes.chave_pix" readonly>
                    </v-card-text>
                </v-card>

                <v-footer fixed class="pa-4">
                    <div class="d-flex flex-column mb-1" style="width: 100%;">
                        <div class="d-flex justify-space-between" style="font-size: 14px;">
                            <span>{{ $t('envio.subtotal') }}</span>
                            <strong>{{ formatMoney(+getSubtotal, '\u00a0') }}</strong>
                        </div>

                        <div v-if="valorAcrescimo" class="d-flex justify-space-between" style="font-size: 14px;">
                            <span>{{ $t('envio.acrescimo') }}</span>
                            <strong>{{ formatMoney(+valorAcrescimo, '\u00a0') }}</strong>
                        </div>

                        <div v-if="valorDesconto" class="d-flex justify-space-between" style="font-size: 14px;">
                            <span>{{ $t('envio.desconto') }}</span>
                            <strong>{{ formatMoney(+valorDesconto, '\u00a0') }}</strong>
                        </div>

                        <div v-if="valorPremio" class="d-flex justify-space-between" style="font-size: 14px; color: #4caf50;">
                            <span>
                                <v-icon small color="green">mdi-gift-outline</v-icon>
                                {{ $t('envio.premio') }}
                            </span>
                            <strong>- {{ formatMoney(valorPremio, '\u00a0') }}</strong>
                        </div>

                        <div v-if="valorFrete" class="d-flex justify-space-between" style="font-size: 14px; line-height: 22px;">
                            <span>{{ $t('envio.taxaEntrega') }}</span>
                            <strong :style="freteGratis ? 'text-decoration: line-through;' : ''">
                                {{ formatMoney(+valorFrete, '\u00a0') }}
                            </strong>
                        </div>

                        <div class="d-flex justify-space-between" style="font-size: 20px; font-weight: bold; line-height: 22px;">
                            <span>{{ $t('envio.total') }}</span>
                            <span>{{ formatMoney(+getTotal + +getValorFrete, '\u00a0') }}</span>
                        </div>
                    </div>

                    <!-- <MercadoPagoCheckout ref="mercadoPago" /> -->

                    <v-btn
                        v-if="onlinePayment && getTotalFinal > 0"
                        @click="onPayClick"
                        :loading="loading"
                        color="success"
                        x-large
                    >
                        <v-icon>mdi-cash</v-icon>&nbsp;
                        {{ $t('envio.pagar') }}
                    </v-btn>
                    <v-btn
                        v-else
                        @click="send()"
                        :loading="loading"
                        color="success"
                        x-large
                    >
                        <v-icon>mdi-whatsapp</v-icon>&nbsp;
                        {{ $t('envio.enviar') }}
                    </v-btn>
                </v-footer>

                <v-dialog v-model="dialogFinalizado" persistent max-width="315">
                    <v-card>
                        <v-card-title class="headline justify-center">
                            {{ $t('envio.pedidoConfirmado') }}
                        </v-card-title>
                        <v-card-text class=text-center>
                            <v-icon color="green" style="font-size: 80px;">
                                mdi-checkbox-marked-circle-outline
                            </v-icon>
                            <br>
                            <br>
                            <b>{{ $t('envio.filaPreparo1') }}<br>{{ $t('envio.filaPreparo2') }}</b>
                            <br>
                            <span v-if="clienteEncaminharPedidoWhatsapp">
                                {{ $t('envio.envieNoWhatsapp') }}
                            </span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                v-if="clienteEncaminharPedidoWhatsapp"
                                color="green"
                                class="white--text"
                                @click="sendWhatsapp"
                                block
                            >
                                <v-icon>mdi-whatsapp</v-icon>&nbsp;
                                <span>{{ $t('envio.enviarNoWhatsapp') }}</span>
                            </v-btn>
                            <v-btn
                                v-else
                                color="green"
                                class="white--text"
                                @click="acompanharPedido"
                                block
                            >
                                <span>{{ $t('envio.acompanharPedido') }}</span>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <OutOfStockDialog
                    v-model="outOfStockDialog.data"
                    :visible="outOfStockDialog.visible"
                    @close="outOfStockDialogClose"
                    @onGoBack="goBack"
                    @onContinue="send()"
                />

                <InactiveItemDialog
                    v-model="inactiveItemDialog.data"
                    :visible="inactiveItemDialog.visible"
                    @onGoBack="goBack"
                />

                <Login
                    v-if="showLoginDialog"
                    v-model="telefone"
                    @login="onLogin"
                    @close="showLoginDialog = false"
                />
            </v-main>
        </template>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
// import MercadoPagoCheckout from './MercadoPagoCheckout';
import Login from '@/pages/auth/Login';
import TelefoneInput from '@/components/TelefoneInput';
import { codigoPostalValido, isBrasil, pais, telefoneInternacional, telefoneValido } from '@/utils/paises';
import { linhaEnderecoEua } from '@/utils/enderecoFormato';
import { ehDinheiro, ehPix } from '@/utils/sistema';
import { IDIOMA_PADRAO } from '@/i18n';
import { moedaAtual } from '@/utils/moeda';
import AddressSelector from './AddressSelector';
import OutOfStockDialog from './OutOfStockDialog';
import InactiveItemDialog from './InactiveItemDialog';
import FormaPagamentoSelect from './FormaPagamentoSelect';
import distance from '@/utils/distance';
import gmapsInit from '@/plugins/gmaps';
import enderecosApi from '@/utils/enderecos';
import { clone, isMobile } from '@/utils/utils';
import { isOpen, requireScheduling } from '@/utils/openingHours';
import { mapState, mapActions } from 'vuex';
import {
    total,
    fracao,
    subtotal,
    subtotalGeral,
    itemValido,
    valorTotalComplementos,
} from '@/utils/calc';

export default {
    name: 'Envio',

    components: {
        TelefoneInput,
        Login,
        BaseContainer,
        AddressSelector,
        OutOfStockDialog,
        InactiveItemDialog,
        // MercadoPagoCheckout,
        FormaPagamentoSelect,
    },

    data: () => ({
        email: '',
        msg: '',
        nome: '',
        rua: '',
        troco: '',
        cep: null,
        uf: null,
        loadingCep: false,
        bairro: null,
        municipio: null,
        agendado: false,
        numero: '',
        pixKey: '',
        telefone: '',
        telefoneDdi: null,
        complemento: '',
        formaEntrega: null,
        agendado_hora: '',
        agendado_data: '',
        formaPagamento: '',
        observacaoGeral: '',
        nascimento: '',
        valorFrete: 0,
        tipoLocal: null,
        nomeEdificio: null,
        numeroApartamento: null,

        enderecosSalvos: [],
        selectedEnderecoUuid: null,
        selectedEnderecoSnapshot: null,
        pedidoEnderecoUuid: null,
        dialogEnderecos: false,
        dialogEnderecoForm: false,
        voltarChooser: false,
        formBackup: null,
        enderecosCarregados: false,
        pulseEndereco: false,

        formaEntregaDisabled: {
            delivery: false,
            retirada: false
        },

        deliveryEnabled: false,
        retiradaEnabled: false,
        localEnabled: false,

        comanda: null,
        cart: [],
        municipios: [],
        bairros: [],
        distancias: [],
        formasPagamento: [],
        formasEntrega: [],
        foraRaioEntrega: false,
        coordenadas: null,
        loading: false,
        dialogFinalizado: false,
        outOfStockDialog: {
            visible: false,
            data: {},
        },
        inactiveItemDialog: {
            visible: false,
            data: {},
        },
        googleMaps: null,
        mapCurrentGeolocation: null,
        cupom: null,
        cupomCode: null,
        showCupom: false,
        precisaTroco: true,
        loadingCupom: false,
        // cupom com limite de uso por cliente ou de primeira compra: só vale com o consumidor logado
        cupomRequerLogin: false,
        cupomPrimeiraCompra: false,
        cupomUsosRestantes: null,
        showLoginDialog: false,
        reenviarAposLogin: false,
        pedido: null,
    }),

    computed: {
        ...mapState([
            'configuracoes',
            'orderBump',
            'cliente',
            'grupos',
        ]),

        cssVars() {
            return {
                '--bg-color': this.$theme.primary,
                '--color': '#fff',
                'width': '100%',
            };
        },

        getTipoLocal() {
            const parts = [];

            parts.push(this.tipoLocal);

            if (this.tipoLocal === 'apartamento') {
                parts.push(this.nomeEdificio);
                parts.push(this.numeroApartamento);
            }

            return parts.join(', ');
        },

        getBairros() {
            if (!this.municipio?.id) {
                return this.bairros;
            }

            return this.bairros.filter(b => (!b.municipio_id || (b.municipio_id == this.municipio.id)));
        },

        clienteEncaminharPedidoWhatsapp() {
            return this.configuracoes?.cliente_encaminhar_pedido_whasapp;
        },

        pedirEmail() {
            return !!this.configuracoes?.pedido_email_ativo;
        },

        exigeCep() {
            return !!this.configuracoes?.obrigar_cep_cardapio;
        },

        cepValido() {
            return codigoPostalValido(this.cep, this.configuracoes?.pais);
        },

        paisDaLoja() {
            return pais(this.configuracoes?.pais);
        },

        lojaNoBrasil() {
            return isBrasil(this.configuracoes?.pais);
        },

        rotuloCodigoPostal() {
            return this.$t('endereco.codigoPostal.' + this.paisDaLoja.codigo);
        },

        rotuloEstado() {
            return this.$t('endereco.estado.' + this.paisDaLoja.codigo);
        },

        // Fora do Brasil o bairro é opcional; o frete por bairro continua exigindo escolher na lista.
        bairroObrigatorio() {
            return this.lojaNoBrasil;
        },

        formatoAniversario() {
            return this.$t('envio.formatoAniversario');
        },

        pagamentoEmDinheiro() {
            return ehDinheiro(this.formaPagamento);
        },

        // O texto do pedido em português é o de sempre; nos outros idiomas os nomes do sistema são traduzidos.
        idiomaPortugues() {
            return this.$i18n.locale === IDIOMA_PADRAO;
        },

        // consumidor logado (tem conta) — habilita gerir endereços na conta pelo checkout
        isLogado() {
            return enderecosApi.isAuthenticated();
        },

        isFretePorBairro() {
            return this.configuracoes?.frete_tipo === 'Bairro';
        },

        isFretePorMunicipio() {
            return this.configuracoes?.frete_tipo === 'Município';
        },

        isFretePorDistancia() {
            return this.configuracoes?.frete_tipo === 'Distância';
        },

        isFretePorQuilometragem() {
            return this.configuracoes?.frete_tipo === 'Quilometragem';
        },

        isFretePorDistanciaQuilometragem() {
            return ['Distância', 'Quilometragem'].includes(this.configuracoes?.frete_tipo);
        },

        isFreteACombinar() {
            return this.configuracoes?.frete_tipo === 'A combinar';
        },

        isRetirada() {
            return this.formaEntrega == 1;
        },

        isDelivery() {
            return this.formaEntrega == 2;
        },

        isLocal() {
            return this.formaEntrega == 3;
        },

        getFormaEntregaDescricao() {
            const { id, descricao } = this.formasEntrega.find(e => e.id == this.formaEntrega);

            return this.tSistema('sistema.formaEntrega.' + id, descricao || '');
        },

        formaPagamentoDescricao() {
            return this.nomeFormaPagamento(this.formaPagamento);
        },

        showMunicipioAutocomplete() {
            return this.municipios.length;
        },

        showBairroAutocomplete() {
            if (this.isFreteACombinar) {
                return false;
            }

            const count = this.bairros.filter(b => b.municipio_id == this.municipio?.id).length;

            return (count > 0) || this.isFretePorBairro;
        },

        showAddressSelector() {
            const { latitude, longitude } = this.configuracoes?.geolocalizacao || {};
            return this.isDelivery && !this.isFreteACombinar && latitude && longitude;
        },

        phone() {
            return telefoneInternacional(this.configuracoes?.whatsapp, this.configuracoes?.whatsapp_ddi);
        },

        getBairro() {
            return this.bairro?.descricao || this.bairro || '';
        },

        getMunicipio() {
            return this.municipio?.descricao || this.municipio || '';
        },

        enderecoAtualResumo() {
            return this.enderecoResumo({
                rua: this.rua,
                numero: this.numero,
                bairro: this.getBairro,
                municipio: this.getMunicipio,
                referencia: this.complemento,
                tipo_local: this.tipoLocal,
                nome_edificio: this.nomeEdificio,
                numero_apartamento: this.numeroApartamento,
                cep: this.cep,
                uf: this.uf,
            });
        },

        freteGratis() {
            return (this.cupom?.frete_gratis && this.cupomValidRules) || this.pedidoMinimoFreteGratis;
        },

        pedidoMinimoFreteGratis() {
            const pedidoMinimo = this.configuracoes.pedido_minimo_frete_gratis;
            const valorLimiteTaxaGratis = this.configuracoes.valor_limite_taxa_gratis;

            if (valorLimiteTaxaGratis && this.valorFrete > valorLimiteTaxaGratis) {
                return false;
            }

            return ![null, undefined].includes(pedidoMinimo) && this.getSubtotalGeral >= +pedidoMinimo;
        },

        getValorFrete() {
            return this.freteGratis ? 0 : this.valorFrete;
        },

        getSubtotalGeral() {
            return subtotalGeral(this.cart);
        },

        getSubtotal() {
            return this.cart.reduce((a, b) => a + +subtotal(b), 0);
        },

        getTotal() {
            return total(this.cart, this.valorDesconto, this.valorAcrescimo);
        },

        getTotalFinal() {
            return +this.getTotal + +this.getValorFrete;
        },

        cupomHasRules() {
            if (!this.cupom) {
                return false;
            }

            const {
                formas_entrega: formasEntrega,
                formas_pagamento: formasPagamento,
                grupos
            } = this.cupom.condicoes;

            return formasEntrega || formasPagamento || grupos || this.cupomValorMinimo > 0
                || this.cupom.primeira_compra;
        },

        cupomValidRules() {
            if (!this.cupom) {
                return true;
            }

            const {
                formas_entrega: formasEntrega,
                formas_pagamento: formasPagamento,
                grupos
            } = this.cupom.condicoes;

            const discountCart = grupos?.length
                ? this.cart.filter(e => grupos.includes(e.grupo_id))
                : this.cart;

            if (discountCart.length <= 0) {
                return false
            }

            if (formasEntrega?.length && !formasEntrega.includes(this.formaEntrega)) {
                return false;
            }

            if (formasPagamento?.length && !formasPagamento.includes(this.formaPagamento.id)) {
                return false;
            }

            if (!this.cupomValidRulesValorMinimo) {
                return false;
            }

            return true;
        },

        cupomValidRulesGrupos() {
            if (!this.cupom?.condicoes.grupos?.length) return true;
            return this.cart.some(e => this.cupom.condicoes.grupos.includes(e.grupo_id));
        },
        cupomValidRulesEntrega() {
            if (!this.cupom?.condicoes.formas_entrega?.length) return true;
            return this.cupom.condicoes.formas_entrega.includes(this.formaEntrega);
        },
        cupomValidRulesPagamento() {
            if (!this.cupom?.condicoes.formas_pagamento?.length) return true;
            return this.cupom.condicoes.formas_pagamento.includes(this.formaPagamento.id);
        },

        cupomValorMinimo() {
            return +(this.cupom?.valor_minimo_pedido) || 0;
        },

        cupomValidRulesValorMinimo() {
            if (!this.cupomValorMinimo) return true;
            return this.getSubtotalGeral >= this.cupomValorMinimo;
        },

        cupomFaltaParaMinimo() {
            if (this.cupomValidRulesValorMinimo) return 0;
            return Math.round((this.cupomValorMinimo - this.getSubtotalGeral) * 100) / 100;
        },
        getCupomGrupos() {
            const gruposIds = this.cupom?.condicoes.grupos || [];
            return this.grupos
                .filter(g => gruposIds.includes(g.id))
                .map(g => g.descricao)
                .join(', ');
        },
        getCupomFormasEntrega() {
            const entregaIds = this.cupom?.condicoes.formas_entrega || [];
            return this.formasEntrega
                .filter(f => entregaIds.includes(f.id))
                .map(f => this.tSistema('sistema.formaEntrega.' + f.id, f.descricao))
                .join(this.$t('envio.separadorOu'));
        },
        getCupomFormasPagamento() {
            const pagamentoIds = this.cupom?.condicoes.formas_pagamento || [];
            return this.formasPagamento
                .filter(f => pagamentoIds.includes(f.id))
                .map(f => this.nomeFormaPagamento(f))
                .join(this.$t('envio.separadorOu'));
        },

        valorDesconto() {
            let desconto = 0;
            let discountCart = this.cart;

            const cupomAplicavel = !!this.cupom && this.cupomValidRules;

            if (this.cupom) {
                const { grupos: gruposIds } = this.cupom.condicoes;

                if (gruposIds?.length) {
                    discountCart = this.cart.filter(e => gruposIds.includes(e.grupo_id));
                }
            }

            const total = subtotalGeral(discountCart);

            const cupomPercentual = +(this.cupom?.percentual || 0);
            const cupomValor = +(this.cupom?.valor) || 0;

            const formaPgtoPercentual = +(this.formaPagamento.desconto_percentual || 0);
            const formaPgtoValor = +(this.formaPagamento.desconto_valor) || 0;

            if (cupomAplicavel) {
                cupomValor && (desconto += cupomValor);
                cupomPercentual && (desconto += total * cupomPercentual / 100);
            }

            formaPgtoValor && (desconto += formaPgtoValor);
            formaPgtoPercentual && (desconto += total * formaPgtoPercentual / 100);

            return Math.min(desconto, subtotalGeral(this.cart));
        },

        valorAcrescimo() {
            const totPed = this.getSubtotalGeral + this.getValorFrete;
            const percentual = +(this.formaPagamento.acrescimo_percentual || 0);
            const valor = +(this.formaPagamento.acrescimo_valor) || 0;

            let acrescimo = 0;

            valor && (acrescimo += valor);
            percentual && (acrescimo += totPed * percentual / 100);

            return Math.round(acrescimo * 100) / 100;
        },

        valorPremio() {
            const premios = this.cart.filter(a => a.premio);

            if (!premios?.length) {
                return 0;
            }

            return premios.reduce((a, b) => a + +subtotal(b), 0);
        },

        permitirAgendamento() {
            return this.configuracoes.agendamento?.ativo;
        },

        agendamentoObrigatorio() {
            return requireScheduling();
        },

        agendamentoExibirHorario() {
            return !this.configuracoes.agendamento?.ocultarHorario;
        },

        agendamentoFormatted() {
            return this.agendado_data
                ? this.moment(this.agendado_data).format('dddd, DD/MM/YYYY')
                : '';
        },

        agendamentoDatas() {
            const dias = [];
            const hoje = this.moment().startOf('day');

            for (let i = 0; i < 90; i++) {
                const data = hoje.clone().add(i, 'days');

                if (!this.allowedDates(data)) continue;

                const text = data.format('dddd').replace('-feira','').charAt(0).toUpperCase() +
                    data.format('dddd').replace('-feira','').slice(1) +
                    data.format(', ' + this.$t('envio.formatoData'));

                dias.push({
                    text,
                    value: data.format('YYYY-MM-DD'),
                });
            }

            return dias;
        },

        exibirAniversario() {
            const userdata = localStorage.getItem('zapermenu-userdata');
            const { nascimento } = JSON.parse(userdata) || {};

            return this.configuracoes.fidelidade?.aniversario_ativo
                && !nascimento; // se está em cache localStorage não exibe mais
        },

        obrigarPreenchimentoAniversario() {
            return this.configuracoes.fidelidade?.aniversario_obrigatorio;
        },

        impressao() {
            return this.configuracoes.impressao;
        },

        // O valor é sempre "HH:mm - HH:mm" (é o que a API lê); fora do português só o texto muda ("6:00 PM - 6:30 PM").
        horarios() {
            const horarios = this.gerarHorarios();

            return this.idiomaPortugues
                ? horarios
                : horarios.map(faixa => ({ text: this.faixaHorarioExibida(faixa), value: faixa }));
        },

        hasCupom() {
            return this.configuracoes.cupons;
        },

        onlinePayment() {
            // Só oferece pagamento online quando o Mercado Pago está conectado;
            // senão cai no fluxo normal (enviar no WhatsApp / Pix manual).
            return this.formaPagamento?.pagamento_online
                && this.configuracoes?.pagamento_online_disponivel;
        },

        showPixDetails() {
            return ehPix(this.formaPagamento) && this.configuracoes.chave_pix && !this.onlinePayment;
        },
    },

    watch: {
        cupomCode() {
            this.cupomRequerLogin = false;
            this.reenviarAposLogin = false;
        },

        'cliente.id'(id) {
            if (!id && this.cupom && (this.cupom.limite_uso_cliente || this.cupom.primeira_compra)) {
                this.removeCupom(false);
                this.notify(this.$t('envio.avisos.cupomExclusivoRemovido'), 'warning');
            }
        },
    },

    mounted() {
        this.$store.commit('setCart', this.$store.getters.getCart.filter(itemValido));
        this.cart = this.$store.getters.getCart;

        if (!this.cart.length) {
            this.goBack();
        }

        this.setConfiguracao();
        this.googleMapsInit();
        this.dadosCache();
        this.carregarEnderecosSalvos();
        this.setCupom();
        this.addOrderBumpInCart();

        if (this.configuracoes.facebook_pixel_id) {
            window.fbq('track', 'InitiateCheckout');
        }
    },

    methods: {
        ...mapActions([
            'userAuthenticate',
        ]),

        setCupom() {
            const codigo = this.$store.getters.getCupom;
            if (!codigo) {
                return;
            }
            this.cupomCode = codigo;
            this.showCupom = true;
            // silencioso: cupom que veio no link não deve abrir a tela com um toast de
            // "faça login" — o aviso na própria seção do cupom já explica o que fazer.
            this.onChangeCupom(true);
        },

        allowedDates(val) {
            const dayOfWeek = this.moment(val).isoWeekday();
            const isHojeAdiante = this.moment(val).isSameOrAfter(this.moment().startOf('day'));
            const horarios = this.configuracoes?.agendamento.horarios;

            const currentDay = horarios.find(e => e.isoWeekday == dayOfWeek);

            return isHojeAdiante && currentDay.aberto;
        },

        obterHorarios(intervalo) {
            const horarios = [];
            const formato = 'HH:mm';

            const [horarioInicio, horarioFim] = intervalo.split(' - ');
            const horaInicio = this.moment(horarioInicio, formato);
            const horaFim = this.moment(horarioFim, formato);
            const horaAtual = this.moment();

            const intervaloHorarioMinutos = this.configuracoes?.agendamento.intervaloHorarioMinutos || 30;
            const tempoEntrega = this.configuracoes.tempo_entrega.split(' - ')[0];
            const tempoRetirada = this.configuracoes.tempo_retirada.split(' - ')[0];
            const tempo = this.isDelivery ? tempoEntrega : tempoRetirada;

            const agendamentoCarencia = this.moment().add(tempo, 'minutes');
            const agendamentoMesmoDia = this.moment(this.agendado_data).isSame(horaAtual, 'day');

            while (horaInicio.isBefore(horaFim)) {
                const start = horaInicio.format(formato);
                horaInicio.add(intervaloHorarioMinutos, 'minutes');
                const end = horaInicio.format(formato);

                const horaStart = this.moment(start, 'HH:mm');
                if (agendamentoMesmoDia && horaStart.isBefore(agendamentoCarencia)) {
                    continue;
                }
                horarios.push(`${start} - ${end}`);
            }

            return horarios;
        },

        gerarHorarios() {
            const horarios = [];
            const { agendado_data, configuracoes, moment } = this;

            if (!agendado_data) {
                return horarios;
            }

            const dayOfWeek = moment(agendado_data).isoWeekday();
            const agendamentoHorarios = configuracoes?.agendamento.horarios;

            const {
                horario,
                segundoHorario,
                segundoHorarioAtivo
            } = agendamentoHorarios.find(e => e.isoWeekday === dayOfWeek);

            horarios.push(...this.obterHorarios(horario));

            if (segundoHorarioAtivo) {
                horarios.push(...this.obterHorarios(segundoHorario));
            }

            return horarios;
        },

        goBack() {
            this.$router.push(`/${this.$route.params.emp}`);
        },

        async setConfiguracao() {
            this.bairros = this.configuracoes.bairros;
            this.distancias = this.configuracoes.distancias;
            this.municipios = this.configuracoes.municipios;

            this.formasPagamento = this.configuracoes.formas_pagamento;
            this.formasEntrega = this.configuracoes.formas_entrega;

            this.retiradaEnabled = this.formasEntrega?.find(e => e.id == 1);
            this.deliveryEnabled = this.formasEntrega?.find(e => e.id == 2);
            this.localEnabled = this.formasEntrega?.find(e => e.id == 3);

            const enabledOptions = [
                this.retiradaEnabled, this.deliveryEnabled, this.localEnabled
            ].filter(e => e);

            if (enabledOptions.length === 1) {
                this.formaEntrega =
                    this.retiradaEnabled?.id
                    || this.deliveryEnabled?.id
                    || this.localEnabled?.id;
            }

            this.agendamentoObrigatorio && (this.agendado = true);

            this.mapCurrentGeolocation = this.configuracoes?.geolocalizacao
                ? {
                    latitude: +this.configuracoes.geolocalizacao.latitude,
                    longitude: +this.configuracoes.geolocalizacao.longitude,
                }
                : null;
        },

        dadosCache() {
            let dados = localStorage.getItem('zapermenu-userdata');
            if (dados) {
                dados = JSON.parse(dados);

                dados.rua && (this.rua = dados.rua);
                dados.cep && (this.cep = dados.cep);
                dados.uf && (this.uf = dados.uf);
                dados.nome && (this.nome = this.cliente.nome || dados.nome);
                dados.numero && (this.numero = dados.numero);
                dados.nascimento && (this.nascimento = dados.nascimento);
                dados.email && (this.email = this.cliente.email || dados.email);
                dados.telefone && (this.telefone = this.cliente.whatsapp || dados.telefone);
                dados.telefone && (this.telefoneDdi = this.cliente.whatsapp ? this.cliente.whatsapp_ddi : dados.telefoneDdi);
                dados.complemento && (this.complemento = dados.complemento);
                // dados.observacao && (this.observacaoGeral = dados.observacao);
                dados.tipoLocal && (this.tipoLocal = dados.tipoLocal);
                dados.nomeEdificio && (this.nomeEdificio = dados.nomeEdificio);
                dados.numeroApartamento && (this.numeroApartamento = dados.numeroApartamento);

                this.bairro = this.showBairroAutocomplete
                    ? this.bairros.find(b => b.descricao == dados.bairro)
                    : dados.bairro;

                this.municipio = this.showMunicipioAutocomplete
                    ? this.municipios.find(b => b.descricao == dados.municipio)
                    : dados.municipio;

            } else {
                this.telefone = this.cliente.whatsapp || '';
                this.telefoneDdi = this.cliente.whatsapp_ddi || null;
                this.nome = this.cliente.nome || '';
            }

            this.onChangeFormaEntrega();
        },

        async carregarEnderecosSalvos() {
            try {
                this.enderecosSalvos = await enderecosApi.sincronizar();
            } catch (e) {
                this.enderecosSalvos = [];
            }

            this.enderecosCarregados = true;

            if (this.enderecosSalvos.length) {
                this.aplicarEnderecoSalvo(this.enderecoPreferido());
            } else if (this.isDelivery) {
                this.abrirFormEndereco('novo');
            }
        },

        aplicarEnderecoSalvo(endereco) {
            if (!endereco) {
                return;
            }

            this.selectedEnderecoUuid = endereco.uuid;
            this.selectedEnderecoSnapshot = { ...endereco };

            this.rua = endereco.rua || '';
            this.numero = endereco.numero || '';
            this.complemento = endereco.referencia || '';
            this.cep = endereco.cep || null;
            this.uf = endereco.uf || null;
            this.tipoLocal = endereco.tipo_local || null;
            this.nomeEdificio = endereco.nome_edificio || null;
            this.numeroApartamento = endereco.numero_apartamento || null;

            this.municipio = this.showMunicipioAutocomplete
                ? (this.municipios.find(m => m.descricao == endereco.municipio) || endereco.municipio)
                : endereco.municipio;

            this.bairro = this.showBairroAutocomplete
                ? (this.bairros.find(b => b.descricao == endereco.bairro) || endereco.bairro)
                : endereco.bairro;

            this.recalcularFreteSelecionado();
            this.dispararPulse();
        },

        dispararPulse() {
            if (!this.isDelivery) {
                return;
            }
            this.pulseEndereco = false;
            this.$nextTick(() => {
                this.pulseEndereco = true;
                clearTimeout(this._pulseTimer);
                this._pulseTimer = setTimeout(() => {
                    this.pulseEndereco = false;
                }, 950);
            });
        },

        recalcularFreteSelecionado() {
            if (!this.isDelivery) {
                this.valorFrete = 0;
                return;
            }

            if (this.isFretePorBairro) {
                this.valorFrete = +(this.bairro && this.bairro.valor) || 0;
            } else if (this.isFretePorMunicipio) {
                this.valorFrete = +(this.municipio && this.municipio.valor) || 0;
            } else if (this.isFretePorDistanciaQuilometragem) {
                this.onAddressChange();
            }
        },

        // ViaCEP só existe para o Brasil; o ZIP americano não tem consulta.
        async consultaCep() {
            if (!this.lojaNoBrasil || !this.cepValido) {
                return;
            }

            const cep = (this.cep || '').replace(/\D/g, '');
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), 4000);

            this.loadingCep = true;
            try {
                const resp = await fetch(`https://viacep.com.br/ws/${cep}/json`, { signal: controller.signal })
                    .then(r => r.json());

                if (resp.erro) {
                    return;
                }

                this.uf = this.uf || resp.uf || null;

                if (!this.municipio) {
                    this.municipio = this.acharNaConfig(this.municipios, resp.localidade);
                }

                if (!this.bairro) {
                    this.bairro = this.showBairroAutocomplete
                        ? this.acharNaConfig(this.getBairros, resp.bairro)
                        : (resp.bairro || null);
                }

                !this.rua && resp.logradouro && (this.rua = resp.logradouro);

                this.recalcularFreteSelecionado();
            } catch (e) {
                // offline, timeout ou CEP inexistente: segue com o que o consumidor digitou
            } finally {
                clearTimeout(timer);
                this.loadingCep = false;
            }
        },

        acharNaConfig(lista, valor) {
            const alvo = (valor || '').toString().trim();

            if (!alvo) {
                return null;
            }

            const igual = descricao => (descricao || '').toString().trim()
                .localeCompare(alvo, 'pt-BR', { sensitivity: 'base' }) === 0;

            return (lista || []).find(i => igual(i.descricao)) || null;
        },

        enderecoPreferido() {
            const ultimo = enderecosApi.getUltimoUuid();
            return this.enderecosSalvos.find(e => e.uuid === ultimo)
                || this.enderecosSalvos.find(e => e.padrao)
                || this.enderecosSalvos[0];
        },

        alterarEndereco() {
            if (this.enderecosSalvos.length) {
                this.abrirEnderecos();
            } else {
                this.abrirFormEndereco('editar');
            }
        },

        abrirEnderecos() {
            this.dialogEnderecos = true;
        },

        abrirFormEndereco(modo, fromChooser = false) {
            this.capturarFormBackup();
            if (modo === 'novo') {
                this.novoEnderecoCheckout();
            }
            this.voltarChooser = fromChooser;
            this.dialogEnderecos = false;
            this.dialogEnderecoForm = true;
        },

        voltarParaChooser() {
            this.restaurarFormBackup();
            this.dialogEnderecoForm = false;
            this.dialogEnderecos = true;
        },

        async confirmarFormEndereco() {
            if (!this.rua || !this.numero) {
                this.notify(this.$t('envio.avisos.informeRuaNumero'), 'warning');
                return;
            }
            if (!this.tipoLocal) {
                this.notify(this.$t('envio.avisos.selecioneTipoEndereco'), 'warning');
                return;
            }
            if (this.exigeCep && !this.cepValido) {
                this.notify(this.$t('envio.avisos.codigoPostalValido', { rotulo: this.rotuloCodigoPostal }), 'warning');
                return;
            }

            const payload = {
                descricao: this.selectedEnderecoSnapshot?.descricao || null,
                rua: this.rua || null,
                numero: this.numero || null,
                bairro: this.getBairro || null,
                municipio: this.getMunicipio || null,
                referencia: this.complemento || null,
                cep: this.cep || null,
                uf: this.uf || null,
                tipo_local: this.tipoLocal || null,
                nome_edificio: this.nomeEdificio || null,
                numero_apartamento: this.numeroApartamento || null,
                valor_frete: this.getValorFrete || null,
                coordenadas: this.coordenadas || null,
            };

            try {
                const salvo = this.selectedEnderecoUuid
                    ? await enderecosApi.update(this.selectedEnderecoUuid, payload)
                    : await enderecosApi.create(payload);

                this.enderecosSalvos = await enderecosApi.list();
                this.selectedEnderecoUuid = salvo.uuid;
                this.selectedEnderecoSnapshot = { ...salvo };
            } catch (e) {
                this.notify(e.message || this.$t('envio.avisos.naoSalvouEndereco'), 'warning');
            }

            this.formBackup = null;
            this.dialogEnderecoForm = false;
            this.dispararPulse();
        },

        cancelarFormEndereco() {
            this.restaurarFormBackup();
            this.dialogEnderecoForm = false;
        },

        capturarFormBackup() {
            this.formBackup = {
                rua: this.rua,
                numero: this.numero,
                complemento: this.complemento,
                cep: this.cep,
                uf: this.uf,
                bairro: this.bairro,
                municipio: this.municipio,
                tipoLocal: this.tipoLocal,
                nomeEdificio: this.nomeEdificio,
                numeroApartamento: this.numeroApartamento,
                observacaoGeral: this.observacaoGeral,
                valorFrete: this.valorFrete,
                coordenadas: this.coordenadas,
                selectedEnderecoUuid: this.selectedEnderecoUuid,
                selectedEnderecoSnapshot: this.selectedEnderecoSnapshot,
            };
        },

        restaurarFormBackup() {
            if (this.formBackup) {
                Object.assign(this, this.formBackup);
                this.formBackup = null;
            }
        },

        selecionarEndereco(endereco) {
            this.aplicarEnderecoSalvo(endereco);
            this.dialogEnderecos = false;
        },

        editarEndereco(endereco) {
            this.aplicarEnderecoSalvo(endereco);
            this.abrirFormEndereco('editar', true);
        },

        async definirEnderecoPadrao(endereco) {
            try {
                await enderecosApi.setPadrao(endereco.uuid);
                this.enderecosSalvos = await enderecosApi.list();
            } catch (e) {
                this.notify(e.message || this.$t('envio.avisos.naoDefiniuPadrao'), 'warning');
            }
        },

        async excluirEndereco(endereco) {
            const ok = await this.$root.$confirm(
                this.$t('envio.excluirEnderecoTitulo'),
                this.$t('envio.excluirEnderecoTexto'),
                { color: 'red darken-1' }
            );
            if (!ok) {
                return;
            }

            try {
                await enderecosApi.remove(endereco.uuid);
                this.enderecosSalvos = await enderecosApi.list();

                if (this.selectedEnderecoUuid === endereco.uuid) {
                    this.enderecosSalvos.length
                        ? this.aplicarEnderecoSalvo(this.enderecoPreferido())
                        : this.novoEnderecoCheckout();
                }
            } catch (e) {
                this.notify(e.message || this.$t('envio.avisos.naoExcluiuEndereco'), 'warning');
            }
        },

        gerenciarEnderecos() {
            this.dialogEnderecos = false;
            this.$root.$emit('myAccount', { tab: 'enderecos' });
        },

        cadastrarOutroEndereco() {
            this.abrirFormEndereco('novo', true);
        },

        novoEnderecoCheckout() {
            this.selectedEnderecoUuid = null;
            this.selectedEnderecoSnapshot = null;

            this.rua = '';
            this.numero = '';
            this.complemento = '';
            this.cep = null;
            this.uf = null;
            this.bairro = null;
            this.municipio = null;
            this.tipoLocal = null;
            this.nomeEdificio = null;
            this.numeroApartamento = null;
            this.valorFrete = 0;
        },

        tipoIcon(tipo) {
            return {
                casa: 'mdi-home-outline',
                apartamento: 'mdi-office-building-outline',
                trabalho: 'mdi-briefcase-outline',
            }[tipo] || 'mdi-map-marker-outline';
        },

        enderecoLabel(endereco) {
            if (!endereco) {
                return '';
            }
            if (endereco.descricao) {
                return endereco.descricao;
            }
            const tipos = ['casa', 'apartamento', 'trabalho', 'condominio'];
            return this.$t('endereco.tipo.' + (tipos.includes(endereco.tipo_local) ? endereco.tipo_local : 'endereco'));
        },

        enderecoResumo(endereco) {
            if (!endereco) {
                return '';
            }
            if (!this.lojaNoBrasil) {
                return this.enderecoResumoEua(endereco);
            }
            const linhaRua = [endereco.rua, endereco.numero].filter(Boolean).join(', ');
            const bairroMun = [endereco.bairro, endereco.municipio].filter(Boolean).join(' - ');
            const partes = [linhaRua, bairroMun];
            if (endereco.tipo_local === 'apartamento') {
                const apto = [endereco.nome_edificio, endereco.numero_apartamento].filter(Boolean).join(', ');
                apto && partes.push(apto);
            }
            const compl = endereco.referencia || endereco.complemento;
            compl && partes.push(compl);
            return partes.filter(Boolean).join(' · ');
        },

        // "123 Main St, Springfield, IL 62701 · Downtown · Bldg, 4B · Ring the bell"
        enderecoResumoEua(endereco) {
            const partes = [linhaEnderecoEua(endereco), endereco.bairro];
            if (endereco.tipo_local === 'apartamento') {
                const apto = [endereco.nome_edificio, endereco.numero_apartamento].filter(Boolean).join(', ');
                apto && partes.push(apto);
            }
            partes.push(endereco.referencia || endereco.complemento);
            return partes.filter(Boolean).join(' · ');
        },

        nomeFormaPagamento(forma) {
            return forma ? this.tSistema('sistema.formaPagamento.' + forma.id, forma.descricao) : '';
        },

        // "18:00 - 18:30" em português; "6:00 PM - 6:30 PM" em inglês.
        faixaHorarioExibida(faixa) {
            if (this.idiomaPortugues || !faixa) {
                return faixa;
            }

            return faixa.split(' - ')
                .map(hora => this.moment(hora, 'HH:mm').format('LT'))
                .join(' - ');
        },

        // Aniversário digitado no formato do idioma (DD/MM ou MM/DD); a API e o aparelho guardam DD/MM.
        nascimentoNormalizado() {
            if (!this.nascimento || this.formatoAniversario === 'DD/MM') {
                return this.nascimento;
            }

            const data = this.moment(this.nascimento, this.formatoAniversario, true);

            return data.isValid() ? data.format('DD/MM') : this.nascimento;
        },

        enderecoFoiAlterado() {
            const s = this.selectedEnderecoSnapshot;
            if (!s) {
                return false;
            }
            return (s.rua || '') !== (this.rua || '')
                || (s.numero || '') !== (this.numero || '')
                || (s.referencia || '') !== (this.complemento || '')
                || (s.bairro || '') !== (this.getBairro || '')
                || (s.municipio || '') !== (this.getMunicipio || '')
                || (s.tipo_local || '') !== (this.tipoLocal || '');
        },

        async resolverEnderecoUuid() {
            if (!this.selectedEnderecoUuid) {
                return null;
            }

            if (this.enderecoFoiAlterado()) {
                const atualizar = await this.$root.$confirm(
                    this.$t('envio.enderecoAlteradoTitulo'),
                    this.$t('envio.enderecoAlteradoTexto'),
                    { color: 'primary', cancel: this.$t('envio.salvarComoNovo') }
                );
                return atualizar ? this.selectedEnderecoUuid : null;
            }

            return this.selectedEnderecoUuid;
        },

        validarCampos() {
            const { status } = isOpen();
            const agendamentoAtivo = this.configuracoes.agendamento?.ativo;

            if (agendamentoAtivo && !status && !this.agendado) {
                this.agendado = true;
                this.notify(this.$t('envio.avisos.encerramosAgende'), 'warning');
                return false;
            }

            if (!status && !agendamentoAtivo) {
                this.notify(this.$t('envio.avisos.encerramos'), 'warning');
                return false;
            }

            if (this.isDelivery && this.foraRaioEntrega) {
                this.notify(this.$t('envio.avisos.foraDoRaio'), 'warning');
                return false;
            }

            const minRetirada = this.configuracoes.pedido_minimo_retirada;
            if (this.isRetirada && minRetirada && minRetirada > +this.getTotal) {
                this.notify(this.$t('envio.avisos.valorMinimo', { valor: this.formatMoneyFixo(minRetirada, ' ') }), 'warning');
                return false;
            }

            const minEntrega = this.configuracoes.pedido_minimo_entrega;
            if (this.isDelivery && minEntrega && minEntrega > +this.getTotal) {
                this.notify(this.$t('envio.avisos.valorMinimo', { valor: this.formatMoneyFixo(minEntrega, ' ') }), 'warning');
                return false;
            }

            if (this.obrigarPreenchimentoAniversario && this.exibirAniversario && (!this.nascimento || !this.moment(this.nascimento, this.formatoAniversario, true).isValid())) {
                this.notify(this.$t('envio.avisos.aniversarioInvalido'), 'warning');
                return false;
            }

            if (this.nascimento && !this.moment(this.nascimento, this.formatoAniversario, true).isValid()) {
                this.notify(this.$t('envio.avisos.aniversarioInvalido'), 'warning');
                return false;
            }

            if (this.configuracoes?.obrigar_sobrenome_cardapio) {
                if (!this.nome || this.nome.trim().split(' ').length < 2) {
                    this.notify(this.$t('envio.avisos.nomeSobrenome'), 'warning');
                    return false;
                }
            } else if (!this.nome?.trim()) {
                this.notify(this.$t('envio.avisos.informeNome'), 'warning');
                return false;
            }
            const telefoneInvalido = isBrasil(this.configuracoes.pais)
                ? this.telefone.length < 15
                : !telefoneValido(this.telefone, this.telefoneDdi);

            if (telefoneInvalido) {
                this.notify(this.$t('envio.avisos.informeWhatsapp'), 'warning');
                return false;
            }
            if (!this.formaEntrega) {
                this.notify(this.$t('envio.avisos.selecioneFormaEntrega'), 'warning');
                return false;
            }

            if (this.agendado || this.agendamentoObrigatorio) {
                if (!this.agendado_data) {
                    this.notify(this.$t('envio.avisos.informeDataAgendamento'), 'warning');
                    return false;
                }
                if (this.agendamentoExibirHorario && !this.agendado_hora) {
                    this.notify(this.$t('envio.avisos.informeHoraAgendamento'), 'warning');
                    return false;
                }
            }

            if (!this.formaPagamento.id) {
                this.notify(this.$t('envio.avisos.informeFormaPagamento'), 'warning');
                return false;
            }

            if (this.precisaTroco && !this.troco && this.pagamentoEmDinheiro) {
                this.notify(this.$t('envio.avisos.informeTroco'), 'warning');
                this.$refs.troco.focus();
                return false;
            }

            if (this.troco && this.pagamentoEmDinheiro) {
                const total = +this.getTotal + +this.getValorFrete;
                if (this.troco < total) {
                    this.$refs.troco.focus();
                    this.notify(this.$t('envio.avisos.trocoMaiorQueTotal'), 'warning');
                    return false;
                }
            }

            if (this.isDelivery) {
                if (this.isFretePorDistanciaQuilometragem && !this.coordenadas) {
                    this.abrirFormEndereco('editar');
                    this.$nextTick(() => this.$refs.addressSelector?.openDialog?.());

                    this.notify(this.$t('envio.avisos.selecioneNoMapa'), 'warning');
                    return false;
                }
                if (this.showMunicipioAutocomplete && !this.municipio) {
                    this.notify(this.$t('envio.avisos.informeMunicipio'), 'warning');
                    return false;
                }
                if (!this.bairro && (this.bairroObrigatorio || this.isFretePorBairro)) {
                    this.notify(this.$t('envio.avisos.informeBairro'), 'warning');
                    return false;
                }
                if (this.isFretePorMunicipio && this.showMunicipioAutocomplete && !(this.municipio && this.municipio.id)) {
                    this.notify(this.$t('envio.avisos.selecioneMunicipioLista'), 'warning');
                    this.abrirFormEndereco('editar');
                    return false;
                }
                if (this.isFretePorBairro && this.showBairroAutocomplete && !(this.bairro && this.bairro.id)) {
                    this.notify(this.$t('envio.avisos.selecioneBairroLista'), 'warning');
                    this.abrirFormEndereco('editar');
                    return false;
                }
                if (!this.rua) {
                    this.notify(this.$t('envio.avisos.informeRua'), 'warning');
                    return false;
                }
                if (!this.numero) {
                    this.notify(this.$t('envio.avisos.informeNumero'), 'warning');
                    return false;
                }
                if (!this.tipoLocal) {
                    this.notify(this.$t('envio.avisos.informeTipoLocal'), 'warning');
                    return false;
                }

                if (this.tipoLocal === 'apartamento' && !this.nomeEdificio) {
                    this.notify(this.$t('envio.avisos.informeEdificio'), 'warning');
                    return false;
                }

                if (this.tipoLocal === 'apartamento' && !this.numeroApartamento) {
                    this.notify(this.$t('envio.avisos.informeApartamento'), 'warning');
                    return false;
                }

                if (this.exigeCep && !this.cepValido) {
                    this.notify(this.$t('envio.avisos.informeCodigoPostalEntrega', { rotulo: this.rotuloCodigoPostal }), 'warning');
                    this.abrirFormEndereco('editar');
                    return false;
                }
            }

            this.saveUserData();

            return true;
        },

        getWhatsappMessage(pedido) {
            const m = (chave, params) => this.$t('envio.mensagem.' + chave, params);
            let text = '';
            let total = this.getTotal || 0;

            text += `*${this.configuracoes.fantasia}*`;
            text += `\n\n${m('pedido', { id: pedido.id })}\n`;

            if (this.agendado) {
                const data = this.moment(this.agendado_data).format(this.$t('envio.formatoData'));
                const hora = this.faixaHorarioExibida(this.agendado_hora);
                text += `${m('agendadoPara', { data, hora })}\n\n`;
            }
            text += `${m('nome', { valor: this.nome })}\n`;
            this.telefone && (text += `${m('whatsapp', { valor: this.telefone })}\n`);
            text += `${m('formaEntrega', { valor: this.getFormaEntregaDescricao })}\n`;
            if (pedido.prazo_finalizacao) {
                text += `${m('prazo', { valor: this.moment(pedido.prazo_finalizacao).format(m('formatoDataHora')) })}\n`;
            }
            text += `${m('pagamento', { valor: this.formaPagamentoDescricao })}\n`;

            if (this.isDelivery) {
                text += `${m('endereco', { valor: this.enderecoDaMensagem() })}\n`;
            }
            this.observacaoGeral && (text += `${m('obs', { valor: this.observacaoGeral })}\n`);
            this.cupom && this.cupomValidRules && (text += `${m('cupom', { valor: this.cupomCode })}\n`);
            text += `______________________________________\n\n`;

            const complementos = item => {
                item?.passos?.forEach(passo => {
                    let adicional = this.getValorTotalComplementos(passo);
                    text += `   >>> ${passo.descricao} ${adicional ? `_${adicional}_` : ''} <<<\n`;

                    passo.complementos.forEach(adicional => {
                        const qtd = fracao(passo, adicional, { unico: '' });
                        const prefixo = qtd === '' ? '•' : `*${qtd}*`;

                        text += `    ${prefixo} ${adicional.descricao}\n`;
                    });
                });
            };

            this.cart.forEach(i => {
                const qtd = i.quantidade || 1;
                const valor = +i.valor ? `(${this.formatMoneyCru(i.valor)})` : '';
                const premio = i.premio ? m('premioItem') : '';

                text += `*${qtd}* ${i.descricao} ${valor} ${premio}\n`;

                i.produtos?.forEach(item => {
                    text += `  *${item.descricao}*\n`;
                    complementos(item);
                });

                complementos(i);

                i.observacao && (text += `${m('obsItem', { valor: i.observacao })}\n`);

                text += '______________________________________\n';
            });

            if (this.isDelivery) {
                text += `${m('totalProdutos', { valor: this.formatMoney(+this.getSubtotal, '') })}\n`;
                this.valorPremio && (text += `${m('premio', { valor: this.formatMoney(this.valorPremio, '') })}\n`);

                const taxaEntrega = this.isFreteACombinar
                    ? m('aCombinar')
                    : `${this.formatMoney(this.getValorFrete, '')}`;

                text += `${m('taxaEntrega', { valor: taxaEntrega })}\n`;
                text += `${m('totalFinal', { valor: this.formatMoney(this.getValorFrete + +total, '') })}\n`;

                this.troco && this.pagamentoEmDinheiro && (text += `\n${m('trocoPara', { valor: this.formatMoneyCru(this.troco) })}`);
            } else {
                this.valorPremio && (text += `${m('premio', { valor: this.formatMoney(this.valorPremio, '') })}\n`);
                text += m('total', { valor: this.formatMoneyCru(total) });

                this.troco && this.pagamentoEmDinheiro && (text += `\n${m('trocoPara', { valor: this.formatMoneyCru(this.troco) })}`);
            }

            text += `\n\n${m('obrigado')}\n`;

            if (this.isDelivery) {
                text += this.coordenadas
                    ? `https://maps.google.com/?q=${this.coordenadas.latitude},${this.coordenadas.longitude}`
                    : m('envieLocalizacao');
            }

            const baseURL = (document.URL.indexOf('localhost') !== -1)
                ? 'http://localhost:8081'
                : 'https://app.zapermenu.com.br';

            if (this.impressao?.linkImpressaoWhatsapp !== false) {
                text += `\n🖨️ ${baseURL}/imprimir/${this.$route.params.emp}/${pedido.id}`;
            }

            text += `\n\n${m('acompanhe', { link: `${baseURL}/${this.configuracoes.dominio}/acompanhe-seu-pedido/${pedido.uuid.replace(/-/g, '')}` })}`;

            return new Promise(resolve => resolve(text));
        },

        // Endereço na mensagem do pedido: no Brasil, a ordem de sempre; fora, "número rua, cidade, ESTADO ZIP".
        enderecoDaMensagem() {
            if (!this.lojaNoBrasil) {
                return [this.linhaEnderecoAtual(), this.getBairro, this.tipoLocalTexto(), this.complemento]
                    .filter(Boolean)
                    .join(', ');
            }

            const parts = [];

            this.isFretePorMunicipio && parts.push(this.getMunicipio);
            parts.push(this.getBairro);
            parts.push(this.rua);
            parts.push(this.numero);
            parts.push(this.tipoLocalTexto());
            parts.push(this.complemento);

            return parts.join(', ');
        },

        linhaEnderecoAtual() {
            return linhaEnderecoEua({
                rua: this.rua,
                numero: this.numero,
                municipio: this.getMunicipio,
                uf: this.uf,
                cep: this.cep,
            });
        },

        // Em português, o tipo como é gravado ("casa", "apartamento, Edifício, 12"); nos outros idiomas, traduzido.
        tipoLocalTexto() {
            if (this.idiomaPortugues || !this.tipoLocal) {
                return this.getTipoLocal;
            }

            const parts = [this.$t('endereco.tipo.' + this.tipoLocal)];

            if (this.tipoLocal === 'apartamento') {
                parts.push(this.nomeEdificio);
                parts.push(this.numeroApartamento);
            }

            return parts.join(', ');
        },

        buildEnderecoString() {
            if (!this.lojaNoBrasil) {
                return [this.linhaEnderecoAtual(), this.getBairro, this.tipoLocalTexto(), this.complemento]
                    .filter(Boolean)
                    .join(', ');
            }

            const parts = [];
            this.getMunicipio && parts.push(this.getMunicipio);
            this.getBairro && parts.push(this.getBairro);
            this.rua && parts.push(this.rua);
            this.numero && parts.push(this.numero);
            this.getTipoLocal && parts.push(this.getTipoLocal);
            this.complemento && parts.push(this.complemento);

            return parts.filter(Boolean).join(', ');
        },

        async send(requirePayment = false) {
            // if (requirePayment) {
            //     this.$refs.mercadoPago.getCardToken();
            //     return;
            // }

            if (!this.validarCampos()) {
                return;
            }

            if (this.isDelivery && this.isFretePorDistanciaQuilometragem) {
                const endereco = this.buildEnderecoString();
                const ok = await this.$root.$confirm(
                    this.$t('envio.confirmacao'),
                    `${this.$t('envio.confirmaEndereco')}\n\n<h2>${endereco}</h2>`,
                    { color: 'green darken-1', cancel: this.$t('envio.alterar') }
                );
                if (!ok) {
                    this.abrirFormEndereco('editar');
                    this.$nextTick(() => this.$refs.addressSelector?.openDialog?.());
                    return;
                }
            }

            this.pedidoEnderecoUuid = this.isDelivery ? await this.resolverEnderecoUuid() : null;

            this.loading = true;

            try {
                const { data } = await this.criarComanda();

                const { type, msg, outOfStock, data: pedido } = data;

                if (type === 'warning' && outOfStock?.length) {
                    this.outOfStock(outOfStock);
                    return;
                }

                if (type === 'warning' && data.inactiveItems?.length) {
                    this.handleInactiveItems(data.inactiveItems);
                    return;
                }

                if (type === 'warning' && data.cupom_erro) {
                    this.handleCupomErro(data.cupom_erro, msg);
                    return;
                }

                if (type === 'warning') {
                    this.notify(msg, 'warning');
                    return;
                }

                this.pedido = pedido;

                if (this.isDelivery && data.endereco_uuid) {
                    this.pedidoEnderecoUuid = data.endereco_uuid;
                    enderecosApi.setUltimoUuid(data.endereco_uuid);
                }

                if (requirePayment) {
                    this.$router.push(`/${this.$route.params.emp}/pagamento/${pedido.uuid}`);
                    return;
                }

                if (this.clienteEncaminharPedidoWhatsapp) {
                    await this.mountWhatsappMessage(pedido);
                }
                this.dialogFinalizado = true;

                this.finishOrder();
            } catch (e) {
                const error = {
                    name: e?.name ?? 'Error',
                    message: e?.message ?? String(e),
                    stack: e?.stack ?? null,
                    code: e?.code ?? null,
                };

                this.$http.post('logger/order-error', { emp: this.$route.params.emp, pedido_id: this.pedido.id, error });
                this.notify(error.message, 'warning');
            } finally {
                this.loading = false;
            }
        },

        handleCupomErro(erro, msg) {
            this.notify(msg, 'warning');

            if (erro === 'requer_login') {
                this.cupom = null;
                this.cupomRequerLogin = true;
                this.reenviarAposLogin = true;
                this.showCupom = true;
                this.showLoginDialog = true;
                return;
            }

            this.removeCupom(false);
            this.showCupom = true;
        },

        finishOrder() {
            this.rememberEnderecoLocal();
            this.sendPurchaseEvent();
            this.clear();
        },

        rememberEnderecoLocal() {
            if (!this.isDelivery) {
                return;
            }

            enderecosApi.rememberLocal({
                uuid: this.pedidoEnderecoUuid,
                descricao: this.selectedEnderecoSnapshot?.descricao || null,
                rua: this.rua || null,
                numero: this.numero || null,
                bairro: this.getBairro || null,
                municipio: this.getMunicipio || null,
                referencia: this.complemento || null,
                cep: this.cep || null,
                uf: this.uf || null,
                tipo_local: this.tipoLocal || null,
                nome_edificio: this.nomeEdificio || null,
                numero_apartamento: this.numeroApartamento || null,
                valor_frete: this.getValorFrete || null,
            });
        },

        async mountWhatsappMessage(pedido) {
            const msg = await this.getWhatsappMessage(pedido);

            this.msg = window.encodeURIComponent(msg);
        },

        outOfStock(produtos) {
            this.$store.commit('setCart', []);

            this.outOfStockDialog = {
                visible: true,
                data: {
                    outOfStock: produtos,
                },
            };
        },

        handleInactiveItems(items) {
            let cart = clone(this.cart);

            items.forEach(inactive => {
                if (inactive.tipo === 'combo') {
                    cart = cart.filter(item => item.combo_id !== inactive.item_id);
                } else {
                    cart = cart.filter(item => item.produto_id !== inactive.item_id);
                }
            });

            this.$store.commit('setCart', cart);
            this.cart = cart;

            this.inactiveItemDialog = {
                visible: true,
                data: {
                    inactiveItems: items,
                },
            };
        },

        sendPurchaseEvent() {
            if (!this.configuracoes.facebook_pixel_id) {
                return;
            }

            const total = +this.getTotal || 0;

            window.fbq('track', 'Purchase', {
                value: total,
                currency: moedaAtual(),
                content_type: 'product',
            });
        },

        sendWhatsapp() {
            const baseUrl = isMobile() ? 'whatsapp://' : 'https://api.whatsapp.com/';

            window.open(`${baseUrl}send?phone=${this.phone}&text=${this.msg}`);

            this.$router.push(`/${this.$route.params.emp}`);
        },

        clear() {
            this.$store.commit('setCart', []);
        },

        saveUserData() {
            const data = {
                rua: this.rua,
                nome: this.nome,
                cep: this.cep,
                uf: this.uf,
                email: this.email,
                bairro: this.getBairro,
                numero: this.numero,
                telefone: this.telefone,
                telefoneDdi: this.telefoneDdi,
                tipoLocal: this.tipoLocal,
                nascimento: this.nascimentoNormalizado(),
                nomeEdificio: this.nomeEdificio,
                municipio: this.getMunicipio,
                complemento: this.complemento,
                observacao: this.observacaoGeral,
                numeroApartamento: this.numeroApartamento,
            };
            localStorage.setItem('zapermenu-userdata', JSON.stringify(data));
        },

        onChangePrecisaTroco(v) {
            if (!v) {
                this.troco = null;
            }
        },

        async onChangeCupom(silencioso = false) {
            if (!this.cupomCode?.trim()) {
                this.removeCupom(false);
                return;
            }

            this.loadingCupom = true;

            let resultado = null;

            await this.$http.post('cupom/validar', {
                codigo: this.cupomCode.trim(),
                entrega: this.formaEntrega,
                forma_pagamento: this.formaPagamento?.id,
                grupos: this.cart.map(i => i.grupo_id),
                subtotal: this.getSubtotalGeral,
            }).then(resp => {
                resultado = resp.data?.type === 'success' ? resp.data.data : null;
            })
            .catch(err => {
                const msg = err?.response?.status === 429
                    ? this.$t('envio.avisos.muitasTentativasCupom')
                    : this.$t('envio.avisos.verifiqueConexao');
                this.notify(msg, 'warning');
            })
            .finally(() => (this.loadingCupom = false));

            if (!resultado) {
                return;
            }

            this.cupomRequerLogin = false;
            this.cupomPrimeiraCompra = !!resultado.primeira_compra;
            this.cupomUsosRestantes = null;

            if (resultado.motivo === 'requer_login') {
                this.cupom = null;
                this.cupomRequerLogin = true;
                silencioso || this.notify(resultado.msg, 'warning');
                return;
            }

            if (resultado.motivo === 'valor_minimo') {
                this.cupom = resultado.cupom;
                this.cupomUsosRestantes = resultado.usos_restantes;
                silencioso || this.notify(resultado.msg, 'warning');
                return;
            }

            if (!resultado.ok) {
                this.cupom = null;
                this.cupomCode = '';
                this.notify(resultado.msg || this.$t('envio.avisos.cupomInvalido'), 'warning');
                return;
            }

            this.cupom = resultado.cupom;
            this.cupomUsosRestantes = resultado.usos_restantes;

            silencioso || this.notify(this.$t('envio.avisos.cupomParabens'));
        },

        async onLogin() {
            this.showLoginDialog = false;
            this.notify(this.$t('envio.avisos.loginSucesso'));

            await this.userAuthenticate();

            this.cliente?.whatsapp && (this.telefone = this.cliente.whatsapp);
            this.cliente?.whatsapp && (this.telefoneDdi = this.cliente.whatsapp_ddi);
            this.nome = this.nome || this.cliente?.nome || '';

            await this.carregarEnderecosSalvos();

            if (this.cupomCode) {
                await this.onChangeCupom(true);

                if (!this.cupom) {
                    this.reenviarAposLogin = false;
                } else if (this.cupomValidRules) {
                    this.notify(this.$t('envio.avisos.cupomAplicado'));
                } else {
                    this.notify(this.$t('envio.avisos.faltamParaCupom', { valor: this.formatMoney(this.cupomFaltaParaMinimo) }), 'warning');
                }
            }

            if (this.reenviarAposLogin && this.cupom) {
                this.reenviarAposLogin = false;
                this.send(this.onlinePayment);
            }
        },

        onChangeMunicipio() {
            if (!this.isDelivery) {
                return;
            }

            if (this.bairro && typeof this.bairro === 'object') {
                this.bairro = null;
            }

            if (!this.isFretePorMunicipio || !this.formaEntrega) {
                return;
            }

            this.valorFrete = +this.municipio?.valor || 0;
            this.valorFrete && !this.freteGratis
                && this.notify(this.$t('envio.avisos.taxaEntrega', { valor: this.formatMoneyFixo(this.valorFrete) }));
        },

        onChangeBairro() {
            if (!this.isDelivery) {
                return;
            }

            if (this.isFretePorDistanciaQuilometragem) {
                this.onAddressChange();
                return;
            }

            if (!this.formaEntrega) {
                return;
            }

            this.valorFrete = +this.bairro?.valor || 0;
            this.valorFrete && !this.freteGratis
                && this.notify(this.$t('envio.avisos.taxaEntrega', { valor: this.formatMoneyFixo(this.valorFrete) }));
        },

        onChangeFormaEntrega() {
            if (!this.isDelivery) {
                this.valorFrete = 0;
                return;
            }

            if (this.isFretePorBairro) {
                this.onChangeBairro();
            }
            if (this.isFretePorMunicipio) {
                this.onChangeMunicipio();
            }
            if (this.isFretePorDistanciaQuilometragem) {
                this.onAddressChange();
            }

            if (!this.enderecosCarregados) {
                return;
            }
            if (!this.enderecosSalvos.length) {
                this.abrirFormEndereco('novo');
            } else if (!this.selectedEnderecoUuid) {
                this.aplicarEnderecoSalvo(this.enderecoPreferido());
            }
        },

        validarRaioEntrega(pos, dis = null) {
            this.foraRaioEntrega = false;

            let km = dis;

            if (pos) {
                this.coordenadas = {
                    latitude: pos.lat,
                    longitude: pos.lng
                };

                km = distance.between(this.configuracoes.geolocalizacao, this.coordenadas);
            }

            const limiteEntrega = Math.max.apply(Math, this.distancias.map(o => o.fim));

            if (km > limiteEntrega) {
                this.foraRaioEntrega = true;
                this.notify(this.$t('envio.avisos.foraDoRaio'), 'warning');
                return;
            }

            this.distancias.forEach(f => {
                if (km >= +f.inicio && km <= +f.fim) {
                    this.valorFrete = +f.valor;
                    this.notify(this.$t('envio.avisos.taxaEntrega', { valor: this.formatMoneyFixo(this.valorFrete) }));
                }
            });
        },

        onBtnOkClick() {
            this.$router.push(`/${this.$route.params.emp}`);
        },

        addOrderBumpInCart() {
            this.cart = this.cart.concat(this.orderBump);
        },

        criarComanda() {
            this.cart.forEach(i => {
                i.produtos?.forEach(e => {
                    e.produto_id = clone(e.produto_id || e.id);
                    e.id = null;
                });

                let type = i.hasOwnProperty('produtos') ? 'combo_id' : 'produto_id';
                i[type] = clone(i[type] || i.id);
                i.id = null;
                i.quantidade = i.quantidade || 1;
                i.total = +subtotal(i);
            });

            const ddmmyyyy = this.moment(this.agendado_data).format('YYYY-MM-DD');
            const hhmm = this.agendado_hora;
            const agendado_datahora = this.agendado ? `${ddmmyyyy} ${hhmm}` : null;

            this.comanda = {
                app: true,
                origem: 'cardapio',
                pessoas: 1,
                pronto: false,
                impresso: false,
                cliente: this.nome,
                troco: this.troco || 0,
                whatsapp: this.telefone,
                whatsapp_ddi: this.telefoneDdi,
                agendado: this.agendado,
                produtos: clone(this.cart),
                nascimento: this.nascimentoNormalizado(),
                valor_frete: this.getValorFrete,
                cupom: this.cupomCode || null,
                entrega: this.formaEntrega,
                desconto: this.valorDesconto || 0,
                acrescimo: this.valorAcrescimo || 0,
                frete_gratis: this.freteGratis,
                observacao: this.observacaoGeral || '',
                forma_pagamento: this.formaPagamento.id,
                agendado_datahora,
                // Snapshot no pedido: o aviso de status usa o endereço informado
                // aqui, não o que estiver no cadastro do cliente meses depois.
                email: this.pedirEmail ? (this.email || null) : null,
            };

            const ads = this.$store.getters.getAds;
            const mesa = this.$store.getters.getMesa;

            ads && (this.comanda.observacao += `\nAds: ${ads}`);
            mesa && (this.comanda.mesa = mesa);

            if (this.isDelivery) {
                this.comanda.endereco = {
                    uuid: this.pedidoEnderecoUuid || undefined,
                    descricao: this.selectedEnderecoSnapshot?.descricao || undefined,
                    rua: this.rua || '',
                    numero: this.numero || '',
                    bairro: this.getBairro || '',
                    municipio: this.getMunicipio || '',
                    complemento: this.complemento || '',
                    tipo_local: this.tipoLocal || '',
                    cep: this.cep || undefined,
                    uf: this.uf || undefined,
                };

                if (this.tipoLocal === 'apartamento') {
                    this.comanda.endereco.nome_edificio = this.nomeEdificio || '';
                    this.comanda.endereco.numero_apartamento = this.numeroApartamento || '';
                }

                if (this.coordenadas) {
                    this.comanda.endereco.coordenadas = {
                        latitude: this.coordenadas?.latitude || '',
                        longitude: this.coordenadas?.longitude || '',
                    };
                }
            }

            this.comanda = clone(this.comanda);

            return this.$http.post('pedido', this.comanda);
        },

        getValorTotalComplementos(passo) {
            const total = valorTotalComplementos(passo);
            return total ? this.$t('envio.mensagem.adicional', { valor: this.formatMoneyFixo(total) }) : '';
        },

        async copyPixKey() {
            const pixKey = document.querySelector('#pixKey');
            pixKey.setAttribute('type', 'text');
            pixKey.select();

            try {
                this.notify(this.$t('envio.avisos.pixCopiada'));
                document.execCommand('copy');
            } catch (err) {
                this.notify(this.$t('envio.avisos.naoCopiou'));
            }

            pixKey.setAttribute('type', 'hidden');
            window.getSelection().removeAllRanges();

            alert(this.$t('envio.avisos.envieAntesDeSair'))
        },

        confirmPosition(position) {
            if (position.results?.length) {
                const components = position.results[1]?.address_components || '';
                components.forEach(e => {
                    if (e.types[0] == 'route') {
                        this.rua = e.short_name;
                    }
                    if (e.types[0] == 'street_number') {
                        this.numero = e.short_name;
                    }
                    if (!this.isFretePorBairro && e.types[0] == 'political') {
                        this.bairro = e.short_name;
                    }
                    if (e.types[0] == 'postal_code' && !this.cep) {
                        this.cep = e.long_name;
                    }
                });
            }

            this.coordenadas = {
                latitude: position.lat,
                longitude: position.lng
            };

            if (this.isFretePorDistanciaQuilometragem) {
                this.validarRaioEntrega(position);
                return;
            }

            this.notify(this.$t('envio.avisos.localizacaoConfirmada'));
        },

        validateAlphaNumericSpaces(event) {
            const keyCode = event.keyCode;
            if (
                (keyCode >= 48 && keyCode <= 57) || // números
                (keyCode >= 65 && keyCode <= 90) || // letras maiúsculas
                (keyCode >= 97 && keyCode <= 122) || // letras minúsculas
                keyCode === 32 || // espaço em branco
                keyCode === 8 || // tecla de retrocesso (backspace)
                keyCode === 46 || // tecla de delete
                keyCode === 37 || // tecla de seta para a esquerda
                keyCode === 96 || // tecla 0
                keyCode === 39 // tecla de seta para a direita
            ) {
                // permitir a entrada de caracteres permitidos
                return true;
            } else {
                // bloquear a entrada de caracteres indesejados
                event.preventDefault();
                return false;
            }
        },

        onPaste(event) {
            event.preventDefault();
            const clipboardData = event.clipboardData || window.clipboardData;
            const pastedText = clipboardData.getData('text');
            const sanitizedText = pastedText.replace(/[^\w\s]/gi, ''); // remover caracteres indesejados
            document.execCommand('insertText', false, sanitizedText); // colar o texto sanitizado
        },

        onChangeAgendadoData() {
            this.agendado_hora = '';
        },

        async googleMapsInit() {
            if (!this.isFretePorDistanciaQuilometragem) {
                return;
            }

            try {
                this.googleMaps = await gmapsInit();
            } catch (e) {
                console.log(e)
            }
        },

        onAddressChange() {
            const parts = [];

            if (!this.rua || !this.numero || (!this.getBairro && this.bairroObrigatorio)) {
                return;
            }

            parts.push(this.getMunicipio || this.configuracoes.municipio);
            parts.push(this.configuracoes.uf);
            this.getBairro && parts.push(this.getBairro);
            this.rua && parts.push(this.rua);
            this.numero && parts.push(this.numero);

            // Fora do Brasil o bairro é opcional: o Google acha o endereço pela rua, cidade, estado e ZIP.
            const address = this.lojaNoBrasil
                ? parts.join(', ')
                : linhaEnderecoEua({
                    rua: this.rua,
                    numero: this.numero,
                    municipio: this.getMunicipio || this.configuracoes.municipio,
                    uf: this.uf || this.configuracoes.uf,
                    cep: this.cep,
                });

            if (this.isFretePorQuilometragem) {
                this.matrix(address);
            }

            if (this.isFretePorDistancia) {
                this.geocoder(address);
            }
        },

        matrix(address) {
            const { latitude, longitude } = this.configuracoes?.geolocalizacao || {};
            const destination = `${latitude}, ${longitude}`;

            const service = new this.googleMaps.maps.DistanceMatrixService();

            service.getDistanceMatrix(
                {
                    origins: [address],
                    destinations: [destination],
                    travelMode: 'DRIVING',
                },
                (response, status) => {
                    if (status === 'OK') {
                        console.log(response)
                        const results = response.rows[0].elements[0];

                        if (results.status === 'OK') {
                            const distance = results.distance.value; // Distância em metros
                            // const duration = results.duration.text; // Tempo estimado

                            // this.notify(
                            //     `Distância calculada: ${distance / 1000} km, Tempo estimado: ${duration}`
                            // );

                            this.validarRaioEntrega(null, distance / 1000);
                        } else if (results.status === 'NOT_FOUND') {
                            this.notify(this.$t('envio.avisos.enderecoNaoEncontrado'));
                        } else if (results.status === 'ZERO_RESULTS') {
                            this.notify(this.$t('envio.avisos.semRotas'));
                        }
                    } else {
                        this.notify(this.$t('envio.avisos.falhaDistancia'));
                        console.log(`Falha ao calcular distância. Status: ${status}`);
                    }
                }
            );
        },

        geocoder(address) {
            const geocoder = new this.googleMaps.maps.Geocoder();

            geocoder.geocode({ address }, (results, status) => {
                if (status === 'OK') {
                    const lat = results[0].geometry.location.lat();
                    const lng = results[0].geometry.location.lng();

                    this.mapCurrentGeolocation = { latitude: lat, longitude: lng };

                    this.validarRaioEntrega({ lat, lng });
                 } else if (status === 'ZERO_RESULTS') {
                    this.notify(this.$t('envio.avisos.enderecoNaoEncontrado'));
                } else {
                    this.notify(this.$t('envio.avisos.falhaGeocodificacao'));
                    console.log(`Falha na geocodificação. Status: ${status}`);
                }
            });
        },

        outOfStockDialogClose() {
            this.outOfStockDialog = {
                visible: false,
                data: {},
            };
        },

        onPayClick() {
            const REQUIRE_PAYMENT = true;
            this.send(REQUIRE_PAYMENT);
        },

        removeCupom(avisar = true) {
            this.cupom = false;
            this.cupomCode = null;
            this.cupomRequerLogin = false;
            this.cupomUsosRestantes = null;
            avisar && this.notify(this.$t('envio.avisos.cupomRemovido'), 'warning');
        },

        acompanharPedido() {
            this.$router.push(`/${this.$route.params.emp}/acompanhe-seu-pedido/${this.pedido.uuid}`);
        },
    },
}
</script>

<style scoped>
.v-card {
    padding: 0 10px 0 10px;
}

.endereco-resumo {
    border-left-width: 4px;
    transition: box-shadow 0.25s ease, border-color 0.25s ease;
}

.endereco-resumo {
    position: relative;
}

.endereco-resumo--ativo {
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);
}

@property --trace-ang {
    syntax: '<angle>';
    inherits: false;
    initial-value: 0deg;
}

.endereco-resumo--trace::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 2px;
    background: conic-gradient(
        from var(--trace-ang, 0deg),
        transparent 0deg,
        transparent 300deg,
        var(--trace-color, #d32f2f) 345deg,
        transparent 360deg
    );
    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor;
    mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    mask-composite: exclude;
    pointer-events: none;
    animation: enderecoTrace 0.9s linear;
}

@keyframes enderecoTrace {
    from {
        --trace-ang: 0deg;
    }
    to {
        --trace-ang: 360deg;
    }
}

.tipo-local-radios ::v-deep .v-radio {
    margin-bottom: 4px;
}

.tipo-local-radios ::v-deep .v-radio .v-label {
    font-size: 13px;
}

.v-btn--active {
    background-color: var(--bg-color) !important;
    color: var(--color) !important;
}

.v-application--is-ltr .v-list-item__avatar:first-child {
    margin-right: 5px;
}

.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.close-btn {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 1;
}
</style>
